import React from "react";
import { NavLink } from "react-router-dom";
import Icon from './ds/Icon';
import { useGlobalState } from '../state';

export default function AccountManagement() {
  const { user, media, setMedia } = useGlobalState();

  function show() {
    document.body.classList.add('menu');
    document.querySelector('#app > div').scrollTop = 0;
  }

  const medias = user.medias.sort((a, b) => a.title.localeCompare(b.title));

  return (
    <div id="account-management">
      <img id="media-picture" src={media.logo}/>

      <select
        id="media-selector"
        value={media.id}
        onChange={(e) => setMedia(medias.find((m) => m.id == e.target.value))}
      >
          {medias.map((media) => (
            <option key={media.id} value={media.id}>{media.title}</option>
          ))}
      </select>

      <NavLink to="profile">
        <button
          id="profile-picture"
          style={{
            backgroundImage: user.picture && `url(${user.picture})`,
          }}
        >
        </button>
      </NavLink>

      <button onClick={show}>
        <Icon icon="burger-menu" />
      </button>
    </div>
  )
}
